<template>
<div>
  <div class="col-xs-12 push-50">
    </div>

  <div class="content content-boxed">
    <!-- Information du profile -->
    <div v-if= "planTransactionData.transactionStatusCode=='000'" class="row">
      <div class="col-sm-12 push-50">
        
      </div>
      <h3 class="h1 font-w300 push-10">{{ sectionLabelMyProfile[actualLanguage] }}</h3>
      <div class="block block-themed block-bordered">
        <div class="block-header bg-primary-dark">
              <ul  class="block-options">
                  <li v-if="flagDisplayProfile===0">
                      <button type="button" @click="toggleDisplayProfile()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                  </li>
                  <li v-if="flagDisplayProfile">
                      <button  type="button" @click="toggleDisplayProfile()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                  </li>
              </ul>
          <h2 class="h3 block-title" @click="toggleDisplayProfile()">{{labelTitleProfileInfo[actualLanguage]}}</h2>
        </div>

          <div v-if="flagDisplayProfile" class="block-content">

            <div class="row">
              <div class="col-xs-12">
                  <!-- Static Labels -->
                  <div class="block">

                      <div class="col-xs-12 col-md-6">
                        <div class="block-header">
                              <h1 class="page-heading">{{profileData.profileInfo.email}}</h1>
                        </div>
                        
                        
                        <div class="block-content block-content-narrow">

                            <form class="form-horizontal push-10-t" action="base_forms_elements.html" method="post" onsubmit="return false;">
                                <div class="form-group">
                                    <div class="col-sm-9">
                                        <div class="form-material">
                                            <input v-model="profileData.profileInfo.firstName" class="form-control" type="text" placeholder="Prénom/First Name">
                                            <label for="material-text">{{labelTitleProfileInfoFirstName[actualLanguage]}}</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="col-sm-9">
                                        <div class="form-material">
                                            <input v-model="profileData.profileInfo.lastName" class="form-control" type="text"  placeholder="Nom/Last Name">
                                            <label for="material-text">{{labelTitleProfileInfoLastName[actualLanguage]}}</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="col-sm-9">
                                        <div class="form-material">
                                            <input v-model="profileData.profileInfo.mobilePhoneNumber" class="form-control" type="text"  placeholder="Mobile">
                                            <label for="material-text">{{labelTitleProfileMobilePhone[actualLanguage]}}</label>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="profileData.licences.length > 0" class="form-group">
                                    <div class="col-sm-12">
                                        
                                          <label class="css-input switch switch-success">
                                              <input type="checkbox" checked v-model="profileData.profileInfo.transmitAlert.email">
                                              <span></span> {{ labelOptionAlertEnableEmail[actualLanguage] }}
                                          </label>
                                        
                                    </div>
                                    <div class="col-sm-12">
                                        
                                          <label class="css-input switch switch-success">
                                              <input type="checkbox" checked v-model="profileData.profileInfo.transmitAlert.SMS">
                                              <span></span> {{ labelOptionAlertEnableSMS[actualLanguage] }}
                                          </label>
                                        
                                    </div>
                                </div>

                            </form>
                        </div>
                      </div>

                      <div class="col-xs-12 col-md-6">
                        <div class="col-xs-9">
                          <h5 class="font-w200 text-center">{{profileData.profileConfig.displayEvConfig.label[actualLanguage]}}</h5>
                        </div>
                        <div class="col-xs-3">
                          <label class="css-input switch switch-success">
                              <input type="checkbox" checked v-model="profileData.profileConfig.displayEvConfig.value"><span></span>
                          </label>
                        </div>
                      </div>


                      <div class="col-sm-12 col-md-12">
                        <p><button @click="saveMyProfile()" type="button" class="btn btn-success align-right" name="button">
                          <spinner size="small" v-if="profileIsSaving"></spinner>
                          <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{labelSaveMyProfileBtn[actualLanguage]}}</span></button></p>
                      </div>

                      <div class="col-sm-12 col-md-12">
                          <h5 class="font-w200 text-left">{{labelMyProfileLicence[actualLanguage] }}</h5>
                          
                          <div v-if="profileData.licences.length > 0" class="col-sm-12 col-md-12">
                              <p>{{ labelOrganisation[actualLanguage] }} : {{profileData.licences[0].licenceFromName}}</p>
                              <p>{{ labelLicenceType[actualLanguage] }} : {{profileData.licences[0].licenceLabel[actualLanguage]}}</p>
                              <p><button @click="releaseLicence()" type="button" class="btn btn-success align-right" name="button">{{ buttonLabelReleaseLicence[actualLanguage] }}</button></p>

                              
                          </div>
                          <div v-else class="col-sm-12 col-md-12">
                              <p>{{ labelNoLicence[actualLanguage] }}</p>
                          </div>
                      </div>


                  </div>
                  <!-- END Static Labels -->
              </div>
            </div>

          </div>
        </div>
    </div>




    <!-- Section d'affichage de mon plan -->
    <div v-if= "planTransactionData.transactionStatusCode==='000'" class="row">
      <div class="block block-themed block-bordered">
        <div class="block-header bg-primary-dark">
              <ul class="block-options">
                  <li v-if="flagDisplayMyPlan===0">
                      <button type="button" @click="toggleDisplayMyPlan()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                  </li>
                  <li v-if="flagDisplayMyPlan">
                      <button  type="button" @click="toggleDisplayMyPlan()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                  </li>
              </ul>
          <h2 class="h3 block-title" @click="toggleDisplayMyPlan()">{{labelTitleServiceMyPlan[actualLanguage]}}</h2>
        </div>

          <div v-if="flagDisplayMyPlan" class="block-content">
            <div class="row">
                
              
                <div class="col-sm-12 col-md-12">
                  <my-plan-display></my-plan-display>
                </div>

                <div class="col-sm-12 col-md-12">

                  <div class="col-xs-12 col-md-12">

                    <div class="col-xs-12 col-md-12">
                        <p><button @click="modifyMyServicePlan()" type="button" class="h2 btn btn-success align-right" name="button">{{labelModifyMyPlanBtn[actualLanguage]}}</button></p>
                    </div>

                  </div>

                </div>

            </div>
          </div>
      </div>
    </div>




    <!-- Section d'affichage de mes option de paiement -->
    <div v-if= "planTransactionData.transactionStatusCode==='000'" class="row">
      <div class="block block-themed block-bordered">
        <div class="block-header bg-primary-dark">
              <ul class="block-options">
                  <li v-if="flagDisplayMyPayment===0">
                      <button type="button" @click="toggleDisplayMyPayment()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                  </li>
                  <li v-if="flagDisplayMyPayment">
                      <button  type="button" @click="toggleDisplayMyPayment()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                  </li>
              </ul>
          <h2 class="h3 block-title" @click="toggleDisplayMyPayment()">{{labelTitleServiceMyPayment[actualLanguage]}}</h2>
        </div>

          <div v-if="flagDisplayMyPayment" class="block-content">
            <div class="row">
                
              
                <div class="col-sm-12 col-md-12">
                  <my-payment-info></my-payment-info>
                </div>

            </div>
          </div>
      </div>
    </div>

    <div v-if= "planTransactionData.transactionStatusCode==='000'" class="row">
      <my-payment-history></my-payment-history>
    </div>



    <!-- Section d'affichage des organizations lors de l'affichage d'utilisateur régulier-->
    <div v-if= "planTransactionData.transactionStatusCode==='000' & dashboardFlags.evsensAdminFlag===false" class="row">
        <div v-if = "profileData.managed_organizations.length>0">
          <h3 class="font-w300 push-10">{{sectionLabelOrganization[actualLanguage]}}</h3>
        </div>

        <h5 class="push-10">{{organizationExplanation01[actualLanguage]}}</h5>
        <h5 class="push-10">{{organizationExplanation02[actualLanguage]}}</h5>
        <h5 class=" push-10">{{organizationExplanation03[actualLanguage]}}</h5>

        <div v-for="(organization,index) in profileData.managed_organizations">
          <organization-display :organizationIndex="index" ></organization-display>
        </div>

        <div class="col-sm-12 col-md-6">
          <p><button  @click="showModal('organization-add-form')" type="button" class="btn btn-success align-center" name="button" data-toggle="popover" v-bind:title=this.massageOrganizationRequired[this.actualLanguage]>
            <i class="fa fa-plus fa-1x push-5-r "></i><i class="fa fa-industry fa-1x push-5-r "></i>{{ buttonLabelCreateOrganization[actualLanguage] }}</button></p>
        </div>


    </div>
    




    <div v-if= "planTransactionData.transactionStatusCode==='000'" class="col-sm-12 col-md-12">
      <hr size="50">
    </div>

    <!-- =============================================================== -->
    <!-- Section d'affichage du processus d'achat User -->
    <!-- =============================================================== -->
    <div v-if= "planTransactionData.transactionStatusCode==='050' || planTransactionData.transactionStatusCode==='060' || planTransactionData.transactionStatusCode==='100'" class="row">
      <div class="block block-themed block-bordered">
        <div class="block-header bg-primary-dark">
              <ul class="block-options">
                  <li v-if="flagDisplayPlan===0">
                      <button type="button" @click="toggleDisplayPlan()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                  </li>
                  <li v-if="flagDisplayPlan">
                      <button  type="button" @click="toggleDisplayPlan()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                  </li>
              </ul>
          <h2 class="h3 block-title" @click="toggleDisplayPlan()">{{labelTitleServicePlan[actualLanguage]}}</h2>
        </div>

        <div v-if="flagDisplayPlan" class="block-content">


          <!-- ------------------------------------ -->
          <!-- Section d'application d'un Free Plan associé a un module -->
          <!-- ------------------------------------ -->
          <div v-if="planTransactionData.transactionStatusCode==='050'" class="row align-center push">
              <div class="col-xs-12 col-md-12">
                <h2 class="page-heading push">{{freePlanSectionTitle[actualLanguage]}}</h2>

                <div class="col-xs-12 col-md-12 push">
                  <div class="col-xs-12 col-md-6">
                    <div class="form-group">
                        <label class="col-xs-12">{{freePlanCodeLabel[actualLanguage]}}</label>
                        <div class="col-sm-12">
                            <input v-model="freePlanCode" class="form-control" type="test" id="freePlanCode" name="plaCode" placeholder="Code du plan/Plan code">
                        </div>
                    </div>
                  </div>

                  <div class="col-xs-12 col-md-6">
                    <div class="form-group">
                        <label class="col-xs-12">{{freePlanModuleIDLabel[actualLanguage]}}</label>
                        <div class="col-sm-12">
                            <input v-model="freePlanDeviceId" class="form-control" type="test" id="freePlanCode" name="module ID" placeholder="Code de validation / Validation code">
                        </div>
                    </div>
                  </div>
                </div>


                <div class="col-sm-12 col-md-12 push-30">
                  <p><button @click="applyFreePlan()" type="button" class="btn btn-success align-center" name="button">
                    <spinner size="small" v-if="freePlanIsSaving"></spinner>
                    <span v-else>{{labelFreePlanBtn[actualLanguage]}}</span></button></p>
                </div>
              </div>
          </div>

          <div class="row">
              <div class="col-sm-12 col-md-12">
                <user-plan-table></user-plan-table>
              </div>
          </div>


        </div>
        <div v-else class="block-content">
          <div class="row">
            <div class="col-sm-12 col-md-12">
              {{labelRefreshMessage[actualLanguage]}}
              <p><button @click="reloadPage()" type="button" class="btn btn-success align-right" name="button">{{labelRefreshPageBtn[actualLanguage]}}</button></p>
            </div>
          </div>
        </div>

        <div v-if="flagDisplayPlan" class="row">
            <div class="col-sm-12 col-md-12">
              <p><button @click="returnToMyServicePlan()" type="button" class="h2 btn btn-success align-right" name="button">{{labelReturnToMyProfileBtn[actualLanguage]}}</button></p>
            </div>
        </div>

      </div>
    </div>



    <!-- =============================================================== -->
    <!-- Section d'affichage du processus d'achat forfait Administrateur -->
    <!-- Ce code est aussi dans organization-display ligne 470-->
    <!-- =============================================================== -->
    <div v-if= "planTransactionData.transactionStatusCode==='055' || planTransactionData.transactionStatusCode==='065' || planTransactionData.transactionStatusCode==='105'" class="row">
      <div class="block block-themed">
        <div class="block-header bg-primary-dark">
              <ul class="block-options">
                  <li >
                      <button type="button"><i class="fa fa-angle-double-down fa-2x"></i></button>
                  </li>
              </ul>
          <h2 class="h3 block-title" @click="toggleDisplayPlan()">{{labelTitleServicePlanOrganization[actualLanguage]}}</h2>
        </div>

        <div class="block-content">
          <div class="row">
              <div class="col-sm-12 col-md-12">
                <admin-plan-table></admin-plan-table>
              </div>
          </div>
        </div>

        <div  class="row">
            <div class="col-sm-12 col-md-12">
              <p><button @click="returnToMyServicePlan()" type="button" class="h2 btn btn-success align-right" name="button">{{labelReturnToMyProfileBtn[actualLanguage]}}</button></p>
            </div>
        </div>

      </div>
    </div>




    <!-- =============================================================== -->
    <!-- Après exécution de la transaction réussie, affichage du message seulement -->
    <!-- Ce code est aussi dans organization-display ligne 501-->
    <!-- =============================================================== -->
    <div v-if="planTransactionData.transactionStatusCode === '999'"  class="row">

      <div v-if="planTransactionData.postAction === 'NewSubscription'"  class="row">
          <h4 class="font-w200 text-center">{{labelSubscriptionRecorded[actualLanguage]}}</h4>
      </div>

      <div v-if="planTransactionData.postAction === 'NewAdminSubscription'"  class="row">
          <h4 class="font-w200 text-center">{{labelAdminSubscriptionRecorded[actualLanguage]}}</h4>
      </div>

      <div v-if="planTransactionData.postAction === 'ModifyCreditCard'"  class="row">
          <h4 class="font-w200 text-center">{{labelNewCreditCardRecorded[actualLanguage]}}</h4>
      </div>

      <div  class="row">
          <div class="col-sm-12 col-md-12 push">
          </div>
          <div class="col-sm-12 col-md-12 push">
          </div>
          <div class="col-sm-12 col-md-12 push">
          </div>
          <div class="col-sm-12 col-md-12">
            <p><button @click="returnToMyServicePlan()" type="button" class="h2 btn btn-success align-right" name="button">{{labelReturnToMyProfileBtn[actualLanguage]}}</button></p>
          </div>
      </div>

    </div>


  </div>
</div>
</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'
import CreateGroupForm from '@/views/group/CreateGroupForm'
import CreateSubGroupForm from '@/views/group/CreateSubGroupForm'
import UserPlanTable from './UserPlanTable'
import MyPlanDisplay from './MyPlanDisplay'
import MyPaymentInfo from './MyPaymentInfo'
import MyPaymentHistory from './UserPaymentHistory'
import AdminPlanTable from './AdminPlanTable'
import OrganizationDisplay from './OrganizationDisplay'

export default {
  name: 'GroupIndex',
  data() {
    return {
      flagDisplayProfile : 0,
      flagDisplayPlan : 0,
      flagDisplayMyPlan : 0,
      flagDisplayMyPayment:0,
      profileIsSaving : false,
      actualLanguage : "FR",
      labelTitleProfileInfo: {FR: 'Informations du profil', EN: 'Profile information'},
      labelTitleProfileInfoFirstName: {FR: 'Prénom', EN: 'First name'},
      labelTitleProfileInfoLastName: {FR: 'Nom', EN: 'Last name'},
      labelTitleProfileMobilePhone: {FR: '# Téléphone mobile', EN: 'Mobile phone #'},
      labelOptionAlertEnableEmail: {FR: "Activer transmission d'alerte par courriel", EN: 'Enable email alert transmission'},
      labelOptionAlertEnableSMS: {FR: "Activer transmission d'alerte par message texte", EN: 'Enable text message alert transmission'},


      labelSaveMyProfileBtn : {FR: 'Enregistrer mon profile', EN: 'Save my profile'},
      labelTitleServiceMyPlan: {FR: 'Mon plan de service personnel (lié à Mon Profile)', EN: 'My service plan (linked to My Profile)'},
      labelModifyMyPlanBtn: {FR: 'Modifier mon plan de service', EN: 'Modify my service plan'},
      labelTitleServicePlan: {FR: 'Plan de service utilisateur', EN: 'End user service plan'},
      labelTitleServicePlanOrganization: {FR: 'Plan de service pour les organisations', EN: 'Organization service plan'},
      labelTitleServiceMyPayment: {FR: 'Options de paiement de mon plan personnel (lié à Mon Profile)', EN: 'My personal plan payment options (linked to My Profile)'},
      labelRefreshMessage: {FR: 'Les données du plan ne sont pas disponibles, la page doit être rafraichie pour y avoir accèes. Revenir dans "Mon profil" après le rafraichissement:', EN: 'The service plan data are not available, the web page needs to be refreshed. Come back to "My profile" after refresh:'},
      labelRefreshPageBtn: {FR: 'Rafraichir la page', EN: 'Refresh the web page'},
      labelReturnToMyProfileBtn: {FR: 'Retour à mon profile', EN: 'Return to my profile'},
      labelSubscriptionRecorded: {FR: 'Abonnement enregistré, Merci !', EN: 'Subscription recorded, Thanks !'},
      labelAdminSubscriptionRecorded: {FR: 'Abonnement enregistré, Merci !', EN: 'Subscription recorded, Thanks !'},
      labelNewCreditCardRecorded: {FR: 'Votre nouvelle carte a été enregistré, Merci !', EN: 'New credit card recorded, Thanks !'},


      freePlanSectionTitle:{FR: "Appliquer un plan pré-enregistré", EN: 'Apply pre-recorded user plan'},
      freePlanCodeLabel:{FR: "Code du plan pré-enregistré (ex: 12AB3C5D)", EN: 'Pre-recorded plan code (ex: 12AB3C5D)'},
      freePlanModuleIDLabel:{FR: "Code de validation (ex: 1234-ABCD)", EN: 'Validation code (ex: 1234-ABCD)'},
      freePlanCode : '',
      freePlanDeviceId : '',
      freePlanIsSaving : false,
      labelFreePlanBtn:{FR: "Appliquer le plan", EN: 'Apply included plan'},
      planLoadedMessage:{FR: "Le plan a été appliqué a votre profil. La page sera rafraichie pour lire les informations", EN: 'The plan was applied to your profile, the page will be refresh.'},

      sectionLabelMyProfile:{FR: "Mon profile", EN: 'My profile'},
      labelMyProfileLicence:{FR: "Licence d'accèes à la plateforme gestionaire", EN: 'Manager platform access license'},
      sectionLabelOrganization:{FR: "Mes Organisations", EN: 'My Organizations'},

      organizationExplanation01:{FR: "Pour accéder à la version administrateur de la plateforme EL-iot, vous devez créer une organisation et ensuite adhéré l'organisation à un forfait selon vos besoins.",
                               EN: 'To access the administrator version of the EL-iot platform, you must create an organization and then join the organization to a package according to your needs.'},
      organizationExplanation02:{FR: "La version administrateur permet de regrouper en système des ensembles de modules de mesure ainsi que les appareils mesurés créés.",
                               EN: 'The administrator version makes it possible to group together sets of measurement modules as well as the measured devices created in a system.'},
      organizationExplanation03:{FR: "Cette version de la plateforme facilite le partage d'information entre plusieurs collaborateurs en permettant le partage des systèmes entre plusieurs usagers.",
                               EN: 'This version of the platform facilitates the sharing of information between several collaborators by allowing the sharing of systems between several users.'},


      labelOrganisation:{FR: "Organisation", EN: 'Organization'},
      labelLicenceType:{FR: "Type de licence", EN: 'License type'},
      buttonLabelReleaseLicence:{FR: "Libérer la licence", EN: 'Release license'},
      labelNoLicence:{FR: "Aucune licence enregistrée", EN: 'No license registered'},


      buttonLabelCreateOrganization:{FR: "Créer une organisation", EN: 'Create an organization'},
      massageOrganizationRequired:{FR: "Une organisation est requise pour accéder à la plateforme gestionaire.", EN: 'An organization is required to access the manager platform version.'},
      buttonHelpManagerVersionDocumentation:{FR: "AIDE : Explication de la version gestionaire de la plateforme web", EN: 'HELP : Explanation documentation of the web platform manager version'},

      messageProfileSaved:{FR: "Profil enregistré", EN: 'Profile saved'},
      messageProfileSavedError:{FR: "Erreur d'enregistrement", EN: 'Saving error'},
      messageConfirmLicenceRelease:{FR: "Confirmer la relâche de licence", EN: 'Confirm license release'},
      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},


    }
  },
  components: {
    Spinner,
    UserPlanTable,
    MyPlanDisplay,
    AdminPlanTable,
    MyPaymentInfo,
    MyPaymentHistory,
    OrganizationDisplay
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','dashboardFlags','planTransactionData']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayProfile(){
      this.flagDisplayProfile = ~this.flagDisplayProfile
    },
   toggleDisplayPlan(){
      this.flagDisplayPlan = ~this.flagDisplayPlan
    },
   toggleDisplayMyPlan(){
      this.flagDisplayMyPlan = ~this.flagDisplayMyPlan
    },
   toggleDisplayMyPayment(){
      this.flagDisplayMyPayment = ~this.flagDisplayMyPayment
    },

    reloadPage(){
      window.location.reload()
    },
 


    saveMyProfile(){
        var requestData = {'postAction':'UpdateProfile',
                          'profileData':this.profileData}
        this.profileIsSaving = true
        this.$store.dispatch('sessionStore/postProfile', requestData)
            .then((response) => {
            this.profileIsSaving = false
            if(response.data.Code=='OK'){
                window.alert(this.messageProfileSaved[this.actualLanguage])
                }
                else{
                  window.alert(this.messageProfileSavedError[this.actualLanguage])
                  }
            })
    },


    applyFreePlan(){
        var requestData = {'postAction':'PutFreePlanToUser',
                          'deviceId':this.freePlanDeviceId,
                          'freeCode':this.freePlanCode}
        this.freePlanIsSaving = true
        this.$store.dispatch('sessionStore/postProfile', requestData)
            .then((response) => {
            this.freePlanIsSaving = false
            if(response.data.Code=='OK'){
                window.alert(this.planLoadedMessage[this.actualLanguage])
                this.$store.dispatch('sessionStore/refreshProfileData')
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },




    releaseLicence(){
        var ProceedToAction = false

        if (window.confirm(this.messageConfirmLicenceRelease[this.actualLanguage])){
            ProceedToAction = true
        }

        if(ProceedToAction){
            var requestData = {'postAction':'ReleaseUserLicence',
                                'organizationId': this.profileData.licences[0].licenceFrom,
                                'subscriptionId': this.profileData.licences[0].licenceId.substring(0,22),
                                'userLicenceId': this.profileData.licences[0].licenceId,
                                'licenceIndex':'ND'}
            //console.log(requestData)
            this.$store.dispatch('sessionStore/processSubscription', requestData)
                .then((response) => {
                this.profileIsSaving = false
                if(response.data.Code=='OK'){
                    this.$store.dispatch('sessionStore/refreshProfileData')
                    }
                    else{
                      window.alert(response.data.PromptMessage[this.actualLanguage])
                      }
                })
        }
    },



    modifyMyServicePlan(){
      this.planTransactionData.transactionStatusCode = '050'
      this.planTransactionData.postAction = 'NewSubscription'
      this.flagDisplayPlan = -1
      window.scrollTo(0, 0)
    },

    modifyMyPaymentOption(){
      this.planTransactionData.transactionStatusCode = '100'
      this.planTransactionData.postAction = 'ModifyCreditCard'
      
      this.flagDisplayPlan = -1
    },

    returnToMyServicePlan(){
      this.planTransactionData.transactionStatusCode = '000'
      this.flagDisplayPlan = 0
      window.scrollTo(0, 0)
    },

    //Liste des états:
    //this.planTransactionData.transactionStatusCode
    //'000' : Etat de base, affichage de la page Mon profile avec information du profile et mon plan.
    //'100' : Affichage du choix de plan, pret pour sélection du plan
    //'200' : Affichage des options du plan
    //'300' : Affichage de la facture,politique d'achat et procéder au payment.
    //'999' : Transaction terminée, 

    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()
    //console.log("Profile");
    this.flagDisplayProfile = 0
    this.flagDisplayMyPlan = 0
    this.flagDisplayPlan = 0


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>

<style lang="css">
  .h1 {font-size: 24px;}
  .h2 {font-size: 20px;}
  .h3 {font-size: 16px;}
  .h4 {font-size: 14px;}
  .h5 {font-size: 12px;}

  /* Media Query pour les écrans de moins de 600px de large */
  @media (max-width: 600px) {
      .h1 {font-size: 18px;}
      .h2 {font-size: 16px;}
      .h3 {font-size: 14px;}
      .h4 {font-size: 10px;}
      .h5 {font-size: 8px;}
  }

</style>



// WEBPACK FOOTER //
// Index.vue?5a6935d0